module.exports = __webpack_public_path__ + "public/img/Komunikasi Pelanggan Untuk Kasir-2.0264c376.png";